<template>
  <div>
   <p> {{ question.Description }} </p>
   <p> {{ question.Description2 }} </p>
   <p> {{ question.Description3 }} </p>
  </div>
</template>

<script>
  export default {
    props: {
      question: {
        required: false,
        type: Object,
      },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/surveys/types/Info.vue